// extracted by mini-css-extract-plugin
export default {"btnReply":"BtnReply_btnReply__0Qnpy","btnReply__text":"BtnReply_btnReply__text__wi6dO"};